import { render, staticRenderFns } from "./date_not_available_banner.vue?vue&type=template&id=58679fe8&scoped=true&"
import script from "./date_not_available_banner.vue?vue&type=script&lang=js&"
export * from "./date_not_available_banner.vue?vue&type=script&lang=js&"
import style0 from "./date_not_available_banner.vue?vue&type=style&index=0&id=58679fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58679fe8",
  null
  
)

export default component.exports